import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import { Project } from '../Project'
import type { Task } from '../../task/Task'
import type { IAction } from '../../action/IAction'
import GraphQLJSON from 'graphql-type-json'

@InputType()
export class AddProjectTasksArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  project: Project

  @Field(() => GraphQLJSON)
  tasks: Task[]
}

@InputType()
export class AddProjectTasksResult extends ActionArgs {
  @Field(() => GraphQLJSON)
  tasks: Task[]

  @Field(() => Project)
  project: Project
}

export interface IAddProjectTasks extends IAction<AddProjectTasksResult, AddProjectTasksArgs> {}
